import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Vårt svar på incidenten med eMudhras certifikat",
  header:
    "Säkerhetsuppdatering: Så hanterar Controla incidenten med eMudhras certifikat",
  date: "2026-10-21",
  description:
    "Åtta certifikat utfärdade av eMudhra har visat sig vara komprometterade. Så har vi uppdaterat Controla-appen och våra servrar, och det här betyder det för dig.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
